export default __webpack_public_path__ + "static/media/testimonials-with-link.10a68cad.png";